import { render, staticRenderFns } from "./PaymentModalPromotion.vue?vue&type=template&id=221c4c9a&scoped=true"
import script from "./PaymentModalPromotion.vue?vue&type=script&lang=js"
export * from "./PaymentModalPromotion.vue?vue&type=script&lang=js"
import style0 from "./PaymentModalPromotion.vue?vue&type=style&index=0&id=221c4c9a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221c4c9a",
  null
  
)

export default component.exports